import React from "react";
import { validateNoNumbers } from "../../validators/validateNoNumbers";
import Table from "../Table";
import TableBody from "../Table/TableBody";
import TableHead from "../Table/TableHead";
import getComprasRecientesProductoByUnidad from "../../services/inventario_productos/getComprasRecientesProductoByUnidad";

export default function ModalComprasRecientesProducto({id_unidad, loading, modulosPermisos, getData}){

    const [comprasRecientes, setComprasRecientes] = React.useState([])
    
    const rows = [
        { id: 1, name: "Producto" },
        { id: 2, name: "Cantidad" },
        { id: 3, name: "Costo" }
    ];

    const getUltimasSalidasProducto = ()=>{
        let data = { id_unidad }

        getComprasRecientesProductoByUnidad({values:data})
            .then(respuesta => {
                console.log(respuesta)
                let _res = JSON.parse(respuesta)
                if(_res.response === 'success'){
                    setComprasRecientes(_res.data)
                } else {
                    setComprasRecientes([])
                }
            })
            .catch(err => console.log(err))
    }

    const reload = ()=>{
        getUltimasSalidasProducto()
        getData()
    }

    React.useEffect(getUltimasSalidasProducto, [id_unidad, loading])

    return(
        <div className="modal" id="modalComprasRecientesProducto" tabIndex="-1" role="dialog" aria-labelledby="modalComprasRecientesProductoLabel" aria-hidden="true">
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="modalComprasRecientesProductoLabel">
                            Compras recientes de productos para la unidad
                        </h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {
                            ( comprasRecientes.length === 0 ) &&
                            <p>
                                No hay compras recientes de productos.
                            </p>
                        }
                        {
                            ( comprasRecientes.length !== 0 ) &&
                            <p>
                                Estas son las compras más recientes de productos de la unidad:
                            </p>
                        }
                        {
                            ( comprasRecientes.length !== 0 ) &&

                                <Table>
                                    <TableHead rows={rows} />

                                    <TableBody 
                                        elements={comprasRecientes} 
                                        typeElement="compra_producto_unidad" 
                                        permisosUsuario={modulosPermisos} 
                                        reload={reload}
                                        // setElementToEdit={setMaterialSelected}
                                    />
                                </Table>
                        }
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal">Salir</button>
                    </div>
                </div>
            </div>
        </div>
    )
}